// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fE","seoBlockContent_visible":"c-a_fF"};